// Mock data for INSPIRE STUDIO OXFORD - Updated Workshop Structure

export const workshops = [
  {
    id: 'easter-2025',
    title: "Easter Drama Camp",
    ageGroup: 'Mixed Age',
    season: 'Easter',
    dates: 'April 6-10, 2026',
    time: '9:00 AM - 3:00 PM',
    price: 185,
    description: 'Our Easter holiday workshop combines drama games, creative activities, and performance skills in a fun, supportive environment. Perfect for all ages and abilities!',
    highlights: [
      'Drama games and improvisation',
      'Creative character work',
      'Fun Easter-themed activities',
      'Performance showcase',
      'All materials and snacks included'
    ],
    spotsLeft: 0,
    totalSpots: 35,
    status: 'sold-out',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/lr9d39cm_420D9E0D-2267-44E2-90DD-199105493BCE.jpeg',
    color: 'light-yellow'
  },
  {
    id: 'halloween-2025',
    title: "Tales From The Crypt - A Halloween Workshop",
    ageGroup: '9-14 years',
    season: 'Halloween',
    dates: 'October 26-30, 2026',
    time: '9:00 AM - 3:00 PM',
    price: 200,
    description: 'A spine-tingling Halloween workshop featuring our annual film project! Create atmospheric characters, learn dramatic lighting, and star in your own Halloween production.',
    highlights: [
      'Halloween film production',
      'Professional cinematography techniques',
      'Character creation and costume design',
      'Spooky atmosphere and effects',
      'Take home your film!',
      'All materials and snacks included'
    ],
    spotsLeft: 0,
    totalSpots: 35,
    status: 'sold-out',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/9gr297lc_IMG_3346.jpeg',
    color: 'mid-purple',
    music: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/669sg51a_nikitakondrashev-creepy-511957.mp3'
  },
  {
    id: 'summer-alls-well',
    title: "All's Well That Ends Well - The Musical",
    ageGroup: '11-14 years',
    season: 'Summer',
    dates: 'July 20-24, 2026',
    time: '9:00 AM - 3:00 PM',
    price: 185,
    description: 'Dive into Shakespeare\'s sophisticated comedy reimagined as a musical! Senior students will explore advanced performance techniques, musical numbers, and character development.',
    highlights: [
      'Musical theatre training',
      'Advanced Shakespearean text work',
      'Song and choreography',
      'Character depth and emotion',
      'Full production showcase',
      'Certificate of participation'
    ],
    spotsLeft: 10,
    totalSpots: 35,
    status: 'available',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/yzvrp2k0_IMG_8101.jpeg',
    color: 'mid-blue'
  },
  {
    id: 'summer-midsummer',
    title: "A Midsummer Night's Dream - The Musical",
    ageGroup: '8-10 years',
    season: 'Summer',
    dates: 'July 20-24, 2026',
    time: '9:00 AM - 3:00 PM',
    price: 185,
    description: 'Join us for a magical musical journey into Shakespeare\'s enchanted forest! Young actors will sing, dance, and bring fairy-tale characters to life in this joyful production.',
    highlights: [
      'Learn musical numbers and choreography',
      'Create your own fairy character',
      'Drama games and ensemble work',
      'Musical performance skills',
      'Final showcase for families',
      'All materials and snacks included'
    ],
    spotsLeft: 0,
    totalSpots: 35,
    status: 'sold-out',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/j6yd25ig_4C7B1785-D809-4E99-96FA-A441DD7F59CC.JPG',
    color: 'light-pink',
    music: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/nucbsw1p_folk_acoustic-summer-walk-152722.mp3'
  },
  {
    id: 'summer-billy-liar',
    title: "Billy Liar",
    ageGroup: '11-14 years',
    season: 'Summer',
    dates: 'July 13-17, 2026',
    time: '9:00 AM - 3:00 PM',
    price: 185,
    description: 'Explore this classic British comedy about a young dreamer! Senior students will tackle complex characters, naturalistic performance, and comedic timing in this engaging production.',
    highlights: [
      'Contemporary theatre techniques',
      'Character psychology and motivation',
      'Comedic timing and naturalism',
      'Ensemble scene work',
      'Performance showcase',
      'Certificate of participation'
    ],
    spotsLeft: 0,
    totalSpots: 35,
    status: 'sold-out',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/0di3eedu_2A0A1B6C-CAB3-436F-84AE-3617611975FE.jpeg',
    color: 'mid-green'
  },
  {
    id: 'spring-comedy',
    title: "Comedy Workshop",
    ageGroup: 'Mixed Age',
    season: 'Spring',
    dates: 'May 25-27, 2026',
    time: '8:30 AM - 3:30 PM',
    price: 99,
    venue: 'Cardinal House',
    description: 'We will once again be putting on our comedy sketch show workshop that has been amazingly popular in the past. Join us for three days of laughter, creativity, and performance!',
    highlights: [
      'Comedy sketch writing and performance',
      'Physical comedy and timing techniques',
      'Character development for comedy',
      'Group ensemble work',
      'Final comedy showcase at Cardinal House',
      'All materials and snacks included'
    ],
    spotsLeft: 36,
    totalSpots: 36,
    status: 'available',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/8q30rk4g_C194C8A2-3DC0-4E0D-9BE0-FE17C2625DCC.png',
    color: 'light-yellow'
  },
  {
    id: 'summer-jabberwocky',
    title: "Jabberwocky - A Fantasy Adventure",
    ageGroup: '8-12 years',
    season: 'Summer',
    dates: 'July 13-17, 2026',
    time: '9:00 AM - 3:00 PM',
    price: 185,
    description: 'Journey into Lewis Carroll\'s fantastical world! Young actors will bring the legendary Jabberwock to life through drama, movement, poetry, and creative storytelling in this imaginative adventure.',
    highlights: [
      'Explore classic Lewis Carroll poetry',
      'Creative movement and creature characterization',
      'Fantasy world building and stagecraft',
      'Ensemble storytelling techniques',
      'Final performance showcase',
      'All materials and snacks included'
    ],
    spotsLeft: 10,
    totalSpots: 35,
    status: 'available',
    image: 'https://customer-assets.emergentagent.com/job_drama-kids-workshops/artifacts/15rzq2f6_525DAA5E-6A03-4389-982C-EB7C8CE0E88D.png',
    color: 'mid-purple'
  },
  {
    id: 'summer-macbeth',
    title: "Macbeth",
    ageGroup: '8-12 years',
    season: 'Summer',
    dates: 'August 31 - September 4, 2026',
    time: '8:30 AM - 3:30 PM',
    price: 185,
    venue: 'Cardinal House, OX44 9LT',
    description: 'Finish your summer in style with this terrifying Shakespeare play. Full of murder, mystery, betrayal and revenge.',
    highlights: [
      'Explore Shakespeare\'s darkest tragedy',
      'Character work: ambition, power, and fate',
      'Stage combat and dramatic techniques',
      'Gothic atmosphere and storytelling',
      'Final performance at Cardinal House',
      'All materials and snacks included'
    ],
    spotsLeft: 30,
    totalSpots: 30,
    status: 'available',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_drama-kids-workshops/artifacts/zt9o0zmq_ED3E3E59-CD54-4443-982A-F027235D6E7E.png',
    color: 'mid-purple'
  },
  {
    id: 'christmas-2026',
    title: "Christmas Festive Workshop",
    ageGroup: '7-12 years',
    season: 'Christmas',
    dates: 'December 17-23, 2026',
    time: '8:30 AM - 3:30 PM',
    price: 200,
    description: 'Celebrate the magic of Christmas with our festive workshop! Create a heartwarming Christmas production filled with joy, music, and holiday cheer.',
    highlights: [
      'Christmas themed production',
      'Festive music and carols',
      'Character work and storytelling',
      'Costume and set design',
      'End-of-week performance for families',
      'All materials and festive snacks included'
    ],
    spotsLeft: 35,
    totalSpots: 35,
    status: 'available',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_drama-kids-workshops/artifacts/pap5qyxc_702ECAA9-3062-4968-8DB1-851C7F814E80.png',
    color: 'light-pink'
  }
];

export const testimonials = [
  {
    id: 1,
    parent: 'Sarah Mitchell',
    child: 'Emma, age 9',
    quote: 'Emma came home every day buzzing with excitement! She loved learning about Shakespeare in such a fun, creative way. The final performance brought tears to my eyes.',
    rating: 5,
    workshop: 'Summer Workshop 2024'
  },
  {
    id: 2,
    parent: 'James Peterson',
    child: 'Oliver, age 12',
    quote: 'Oliver has always been shy, but this workshop helped him come out of his shell. The instructors were patient, encouraging, and truly passionate about theatre.',
    rating: 5,
    workshop: 'Easter Workshop 2024'
  },
  {
    id: 3,
    parent: 'Priya Sharma',
    child: 'Aisha, age 8',
    quote: 'INSPIRE STUDIO OXFORD exceeded all expectations! Aisha made wonderful friends and discovered a love for acting. We\'ll definitely be back for the next workshop.',
    rating: 5,
    workshop: 'Halloween Workshop 2024'
  },
  {
    id: 4,
    parent: 'David Thompson',
    child: 'Lucas, age 13',
    quote: 'The quality of teaching is outstanding. Lucas learned so much about Shakespeare, performance, and confidence. Worth every penny!',
    rating: 5,
    workshop: 'Summer Workshop 2024'
  }
];

export const aboutInfo = {
  studioName: 'INSPIRE STUDIO OXFORD',
  tagline: 'Where Young Actors Discover Their Stage',
  mission: 'At INSPIRE STUDIO OXFORD, we believe every child has a story to tell. Our holiday workshops combine the magic of Shakespeare with professional drama techniques, creating an environment where confidence blooms and creativity thrives.',
  approach: [
    'Age-appropriate Shakespeare adaptations',
    'Professional theatre techniques',
    'Inclusive, supportive environment',
    'Small group sizes for individual attention',
    'Focus on confidence building',
    'Fun, engaging drama games'
  ],
  contact: {
    email: 'williamrichard74@gmail.com',
    phone: '07511662530',
    location: 'Oxford, UK'
  }
};

export const faqs = [
  {
    id: 1,
    question: 'What experience does my child need?',
    answer: 'No experience necessary! Our workshops welcome complete beginners as well as experienced young performers. We tailor activities to each child\'s level.'
  },
  {
    id: 2,
    question: 'What should my child bring?',
    answer: 'Please bring a packed lunch, water bottle, comfortable clothing for movement, and lots of enthusiasm! We provide all drama materials and snacks.'
  },
  {
    id: 3,
    question: 'Is there a performance at the end?',
    answer: 'Yes! Each workshop concludes with a showcase performance for family and friends on the final day. It\'s an informal, supportive environment where children can shine.'
  },
  {
    id: 4,
    question: 'What is your cancellation policy?',
    answer: 'Full refunds available up to 14 days before the workshop start date. Within 14 days, we offer a 50% refund or the option to transfer to another workshop.'
  },
  {
    id: 5,
    question: 'How many children are in each workshop?',
    answer: 'We keep our groups manageable with a maximum of 35 children per workshop. This ensures quality instruction while maintaining an energetic, collaborative atmosphere.'
  },
  {
    id: 6,
    question: 'Are snacks provided?',
    answer: 'Yes! We provide healthy snacks throughout the day. Please inform us of any allergies or dietary requirements during booking.'
  }
];

// Mock booking state management
export const mockBooking = {
  cart: [],
  addToCart: (workshop) => {
    const existingCart = JSON.parse(localStorage.getItem('inspireCart') || '[]');
    existingCart.push({
      ...workshop,
      bookingId: Date.now(),
      timestamp: new Date().toISOString()
    });
    localStorage.setItem('inspireCart', JSON.stringify(existingCart));
    return existingCart;
  },
  getCart: () => {
    return JSON.parse(localStorage.getItem('inspireCart') || '[]');
  },
  clearCart: () => {
    localStorage.removeItem('inspireCart');
  },
  removeFromCart: (bookingId) => {
    const existingCart = JSON.parse(localStorage.getItem('inspireCart') || '[]');
    const updatedCart = existingCart.filter(item => item.bookingId !== bookingId);
    localStorage.setItem('inspireCart', JSON.stringify(updatedCart));
    return updatedCart;
  }
};
